(() => {
 const sizeOf = title => /lavish/i.test(title) ? 'lavish' : /luxe/i.test(title) ? 'luxe' : 'lush';
 class BloomVariantBase extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();this.controller=new AbortController();
   this.scope=this.closest('.shopify-section');
   this.group=sizeOf(this.dataset.selected||'');this.update();
   this.scope?.addEventListener('change',e=>{
    if(!e.target.closest('variant-picker'))return;
    const value=e.target.value||'';
    if(/lush|luxe|lavish/i.test(value)){this.group=sizeOf(value);this.update();}
   },{signal:this.controller.signal});
   // Horizon morphs the section after selection; new instances initialize from Liquid.
  }
  disconnectedCallback(){this.controller?.abort();}
 }
 class Gallery extends BloomVariantBase {
  connectedCallback(){super.connectedCallback();this.addEventListener('click',e=>{const b=e.target.closest('[data-bloom-thumb]');if(b&&!b.hidden)this.select(b.dataset.id);},{signal:this.controller.signal});}
  update(){
   this.photos=[...this.querySelectorAll('[data-bloom-photo]')];
   this.thumbs=[...this.querySelectorAll('[data-bloom-thumb]')];
   this.visible=this.photos.filter(p=>p.dataset.group===this.group||p.dataset.group==='shared');
   this.thumbs.forEach(b=>{b.hidden=!(b.dataset.group===this.group||b.dataset.group==='shared');});
   this.select(this.visible[0]?.dataset.id);
   const caption=this.querySelector('.bvg-caption');if(caption)caption.textContent=`The ${this.group==='lavish'?'Lavish':this.group==='luxe'?'Luxe':'Lush'} Loop · ${this.visible.length} photos`;
  }
  select(id){this.photos.forEach(p=>{p.hidden=p.dataset.id!==id;});this.thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.id===id)));}
 }
 class Faq extends BloomVariantBase {update(){this.querySelectorAll('[data-bloom-faq-group]').forEach(p=>{p.hidden=p.dataset.bloomFaqGroup!==this.group;});}}
 if(!customElements.get('bloom-variant-gallery'))customElements.define('bloom-variant-gallery',Gallery);
 if(!customElements.get('bloom-variant-faq'))customElements.define('bloom-variant-faq',Faq);
})();
